export let LogBiEvent = /*#__PURE__*/function (LogBiEvent) {
  LogBiEvent["PageView"] = "page_view";
  LogBiEvent["ModalView"] = "modal_view";
  LogBiEvent["Click"] = "click";
  return LogBiEvent;
}({});